import { Directive, ElementRef, Input, OnInit } from '@angular/core';

@Directive({
    selector: '[checkoutCy]',
    standalone: true,
})
export class DataCyDirective implements OnInit {
    @Input() checkoutCy: string;

    constructor(private el: ElementRef) {}

    public ngOnInit(): void {
        this.el.nativeElement.setAttribute('data-cy', this.checkoutCy);
    }
}
